import messages from './cmsScheduleRowMarker.json' with { type: 'json' };

export const cmsScheduleRowMarkerFi: Readonly<typeof messages> = messages;
